import {TextStyle, ViewStyle} from 'react-native';
import Styles from 'src/components/Styles';

//#region Header

export function getHeaderBackground(content: JSX.Element): JSX.Element {
  return content;
}

export function headerFontSize(): number {
  return Styles.Fonts.headerFont;
}

export function subHeaderFontSize(): number {
  return Styles.Fonts.sectionHeader;
}

export function headerContainerStyleDescriptor(): {
  safeArea: ViewStyle;
  container: ViewStyle;
  headerTextContainer: TextStyle;
  headerTextStyle: TextStyle;
  maxFontSizeMultiplier: number;
} {
  return {
    safeArea: {
      backgroundColor: Styles.Colors.Canteen.primary,
    },
    container: {
      flex: 1,
      backgroundColor: '#F1f5f5',
      flexDirection: 'column',
    },
    headerTextContainer: {
      height: 34,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTextStyle: {
      fontSize: headerFontSize(),
      lineHeight: headerFontSize() + 4,
      color: Styles.Colors.Canteen.lightGreen,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    maxFontSizeMultiplier: Styles.FontSizeMultiplier.maxfm13,
  };
}

export function subHeaderContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    subHeaderTextStyle: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
    },
  };
}

export function getBackIconColor(transparent: boolean): string {
  return transparent
    ? Styles.Colors.PayNew.black01
    : Styles.Colors.Canteen.lightGreen;
}

//#endregion

//#region Body

export function primaryColor(): string {
  return Styles.Colors.Canteen.primary;
}

export function primaryColorButton(): string {
  return Styles.Colors.Canteen.primary;
}

export function bodyLargeFontSize(): number {
  return Styles.Fonts.f7;
}

export function bodyFontSize(): number {
  return Styles.Fonts.f1;
}

export function bodySmallFontSize(): number {
  return Styles.Fonts.f8;
}

export function bodyTinyFontSize(): number {
  return Styles.Fonts.f0;
}

export function shadowStyles(): {
  shadow: ViewStyle;
  lightShadow: ViewStyle;
} {
  const backgroundColor = '#FFFFFF';
  const shadowColor = '#000000';
  const borderColor = '#CFCFCF';
  return {
    shadow: {
      backgroundColor,
      borderWidth: 1,
      borderColor,
      elevation: 6,
      shadowColor,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.2,
      shadowRadius: 4,
    },
    lightShadow: {
      backgroundColor,
      borderWidth: 1,
      borderColor,
      elevation: 3,
      shadowColor,
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.1,
      shadowRadius: 2,
    },
  };
}

//#endregion

//#region Footer

export function bottomTabBtnColor(): string {
  return '#003349';
}

export function getFooterNameTextDesc(isFocused): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    footerNameText: {
      fontSize: 10,
      fontWeight: isFocused ? '700' : 'normal',
      textAlign: 'center',
      fontFamily: mainFontFamily(),
    },
  };
}

//#endregion

export function mainFontFamily(): string {
  return Styles.FontFamily.robotoRegular;
}

export default {
  getHeaderBackground,
  headerContainerStyleDescriptor,
  getBackIconColor,
  headerFontSize,
  subHeaderFontSize,
  bodyFontSize,
  bodyLargeFontSize,
  bodyTinyFontSize,
  bodySmallFontSize,
  subHeaderContainerStyleDescriptor,
  bottomTabBtnColor,
  getFooterNameTextDesc,
  shadowStyles,
  mainFontFamily,
  primaryColor,
  primaryColorButton,
};
